import service from '@/utils/server';

const modName = '/bd/orderImport/';
//查询
export const pageInfo = data => {
  return service({
    url: modName + 'pageInfo',
    method: 'post',
    data
  });
};

//导出数据
export const exportData = data => {
  let config = {
    timeout: 500000, // 请求超时时间
    responseType: "blob"
  };
  return service({
    ...config,
    url: modName + 'exportData',
    method: 'post',
    data
  });
};

//下载文件
export const downloadFile = data => {
  let config = {
    timeout: 500000, // 请求超时时间
    responseType: "blob"
  };
  return service({
    ...config,
    url: modName + 'downloadFile/' + data.id + '/' + data.fileName,
    method: 'post'
  });
};

export const importData = data => {
  let config = {
    timeout: 500000, // 请求超时时间
    responseType: "blob"
  };
  return service({
    ...config,
    url: modName + 'importData',
    method: 'post',
    data
  });
};

export const importOrder = data => {
  let config = {
    timeout: 500000, // 请求超时时间
    responseType: "blob"
  };
  return service({
    ...config,
    url: modName + 'importOrder',
    method: 'post',
    data
  });
};

export const downloadTemplateById = data => {
  let config = {
    timeout: 500000, // 请求超时时间
    responseType: "blob"
  };
  return service({
    ...config,
    url: modName + 'downloadTemplateById/' + data.id,
    method: 'post',
  });
};

export const downloadTemplate = data => {
  let config = {
    timeout: 500000, // 请求超时时间
    responseType: "blob"
  };
  return service({
    ...config,
    url: modName + 'downloadTemplate/' + data.templateName,
    method: 'post',
  });
};


export const listTemplate = data => {
  return service({
    url: modName + 'selectTemplate/'+ data.shipperCode,
    method: 'post'
  })
};



// WEBPACK FOOTER //
// ./src/page/order/orderImport/api/index.js